var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptoImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 62,
    viewBox: "0 0 59 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9791 26.7044H17.372V23.0741C16.936 23.121 16.4719 23.1535 15.9791 23.1735V26.7044Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9325 9.07312H8.06461V10.9064H11.4566L11.9325 9.07312Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4566 21.3529H8.06461V23.1862H12.0601L11.4566 21.3529Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.453 5.29126H12.0601V26.7057H13.453V5.29126Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.979 15.5649V15.523C20.9505 14.9826 22.1445 13.7967 22.1445 12.4444C22.1445 11.3417 21.5616 10.5098 20.5896 9.96943C19.7671 9.4703 18.7482 9.16945 17.3721 9.03247V10.4886C18.8082 10.7613 19.7014 11.4274 19.7014 12.6302C19.7014 13.6416 18.8626 14.4541 17.3721 14.8006V16.5175C19.0747 16.8359 20.2843 17.6371 20.2843 19.0582C20.2843 20.5594 19.0315 21.3281 17.3721 21.6283V23.0744C19.0778 22.8918 20.3582 22.5027 21.2563 21.8872C22.2008 21.2011 22.8394 20.2842 22.8394 19.0789C22.8394 16.9998 20.7566 15.8977 18.9796 15.5643H18.979V15.5649Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.422302,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0378 9.24132V23.0331C12.2832 23.1657 13.5347 23.2213 14.7869 23.1994C16.0804 23.1769 17.3714 23.0718 18.6518 22.8848C17.8705 23.0762 17.2563 22.7091 17.2007 22.3694C17.1494 22.0567 17.544 21.582 18.2095 21.425C17.6285 21.5594 17.0393 21.6576 16.4463 21.7183C16.0091 21.7627 15.6645 21.7815 15.4812 21.7846C14.8045 21.7946 14.1277 21.7671 13.4541 21.7014V16.3555H15.4524C15.7089 16.3473 15.9872 16.3505 16.285 16.3705C16.7253 16.4005 17.1625 16.4656 17.5928 16.5644L17.372 14.8024C17.0337 14.8881 16.6878 14.9444 16.3394 14.9707C16.1086 14.9882 15.8771 14.9926 15.6463 14.9832H13.4541V10.4691C14.755 10.2927 16.0742 10.2996 17.3733 10.491C17.3145 10.0006 17.2563 9.5109 17.1982 9.02053C16.6396 8.98112 16.0579 8.95673 15.4537 8.95048C13.9763 8.93546 12.5008 9.03304 11.0385 9.24132H11.0378Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.422302,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3722 5.29126H15.9792V8.95592C16.4815 8.96593 16.9444 8.9922 17.3722 9.03411V5.29189V5.29126Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5436 56.0497C12.3604 55.7689 10.367 53.4102 10.2545 49.9288H12.7532C12.894 52.315 14.3257 53.803 17.4143 53.803C20.2783 53.803 21.9346 52.6803 21.9346 50.4336C21.9346 48.5246 20.8394 47.6821 18.7059 47.233L15.8418 46.6151C12.7251 45.9414 10.9281 44.3127 10.9281 41.3085C10.9281 38.3044 13.0059 36.2547 16.543 35.9457V33.6433H18.4519V35.9738C21.8495 36.3391 24.1238 38.5846 24.1513 41.7576H21.6525C21.5399 39.6241 20.1363 38.2199 17.3849 38.2199C15.055 38.2199 13.4544 39.2307 13.4544 41.3085C13.4544 42.9085 14.437 43.751 16.5148 44.2282L19.1819 44.8462C22.5513 45.6324 24.4884 47.2049 24.4884 50.4336C24.4884 53.6623 22.1297 55.712 18.4519 56.021V58.3515H16.543V56.0491H16.5436V56.0497Z",
    fill: "#F39200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1147 16.7876L35.3419 26.6757L43.1147 30.6619L51.087 26.6757L43.1147 16.7876Z",
    fill: "#F39200"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3419 29.2665L43.2142 33.0537L51.087 29.2665L43.2142 40.9529L35.3419 29.2665Z",
    fill: "#F39200"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4517 30.9997C23.7361 30.9997 30.4519 24.2839 30.4519 15.9995C30.4519 7.71519 23.7361 0.99939 15.4517 0.99939C7.16737 0.99939 0.451569 7.71519 0.451569 15.9995C0.451569 24.2839 7.16737 30.9997 15.4517 30.9997Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2149 43.869C51.4993 43.869 58.2151 37.1532 58.2151 28.8688C58.2151 20.5845 51.4993 13.8687 43.2149 13.8687C34.9306 13.8687 28.2148 20.5845 28.2148 28.8688C28.2148 37.1532 34.9306 43.869 43.2149 43.869Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9832 60.9997C26.2676 60.9997 32.9834 54.2839 32.9834 45.9995C32.9834 37.7152 26.2676 30.9994 17.9832 30.9994C9.69886 30.9994 2.98306 37.7152 2.98306 45.9995C2.98306 54.2839 9.69886 60.9997 17.9832 60.9997Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoImg);
export default __webpack_public_path__ + "static/media/crypto-img.9e51e9905c4dbe38fa8af587fef42e03.svg";
export { ForwardRef as ReactComponent };